// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".traveler-data .el-dialog__body {\n  padding: 15px;\n}\n.traveler-data .el-table .alert-row {\n  background: #ffaec8;\n}\n.traveler-data .el-table--enable-row-hover .el-table__body tr.alert-row:hover > td {\n  background: #fa95b5;\n}\n.traveler-complaint-remind .el-dialog__body {\n  padding-top: 6px !important;\n  padding-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
